import script from "./pull-quote.vue?vue&type=script&lang=js"
export * from "./pull-quote.vue?vue&type=script&lang=js"

import "./pull-quote.vue?vue&type=style&index=0&id=09c6bbf8&lang=scss"

const __exports__ = script;

export default __exports__